import { render } from "./IndicesPartial.vue?vue&type=template&id=03d396dc&scoped=true"
import script from "./IndicesPartial.vue?vue&type=script&lang=js"
export * from "./IndicesPartial.vue?vue&type=script&lang=js"

import "./IndicesPartial.vue?vue&type=style&index=0&id=03d396dc&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d396dc"]])

export default __exports__